module.exports = __webpack_public_path__ + "assets/images/arrow-down-square2.svg?ver=b23b93b8";